import moment from 'moment'

import { DEFAULT_DATE_FORMAT } from 'constants/date'
import { AddReviewFormVales } from 'module/Safeguarding/MedicationForm/Preview/components/ReviewForm'

import { Review } from '../models'
import { REVIEW_MEDICATION_STATUSES } from '../constants'

export const getBody = (fields: AddReviewFormVales, medicationFormId: number): Review => {
  if (!fields) {
    return null
  }

  const {
    medicationReturnedDate,
    nextReviewDate,
    notes,
    type,
  } = fields

  if (type === REVIEW_MEDICATION_STATUSES.MEDICATION_IS_STILL_NEEDED) {
    return {
      medicationForm: {
        id: medicationFormId,
      },
      nextReviewDate: moment(nextReviewDate).format(DEFAULT_DATE_FORMAT),
      notes,
      type,
    }
  }

  return {
    medicationForm: {
      id: medicationFormId,
    },
    medicationReturnedDate: moment(medicationReturnedDate).format(DEFAULT_DATE_FORMAT),
    notes,
    type,
  }
}

